import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Edit,
  required,
  Create,
  ReferenceField,
  AutocompleteInput,
  ReferenceInput,
  Filter,
  DateField,
  CardActions,
  ListButton,
  CreateButton,
  CloneButton,
  SearchInput
} from 'react-admin'

const CreateActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
  </CardActions>
)

const EditActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
    <CreateButton basePath={basePath} record={data} />
    <CloneButton basePath={basePath} record={data} />
  </CardActions>
)

const Class = {
  filter: (props) => (
    <Filter {...props}>
      <SearchInput label='Search by name' source='name' alwaysOn />
      <ReferenceInput
        label='School'
        source='schoolId'
        reference='school'
        allowEmpty
        filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
      >
        <AutocompleteInput optionText='name' translateChoice={false} />
      </ReferenceInput>
    </Filter>
  ),
  create: (props) => (
    <Create {...props} actions={<CreateActions />} >
      <SimpleForm>
        <TextInput source='name' label='Name' validate={required()} />
        <ReferenceInput
          label='School'
          source='schoolId'
          resource='school'
          reference='school'
          allowEmpty
          validate={required()}
          filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
        >
          <AutocompleteInput optionText='name' translateChoice={false} />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  ),
  edit: (props) => {
    return (
      <Edit {...props} actions={<EditActions />}>
        <SimpleForm>
          <TextField source='id' />
          <TextInput source='name' label='Name' validate={required()} />
          <ReferenceInput
            label='School'
            source='schoolId'
            resource='school'
            reference='school'
            allowEmpty
            validate={required()}
            filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
          >
            <AutocompleteInput optionText='name' translateChoice={false} />
          </ReferenceInput>
          <DateField source='createdAt' showTime />
          <DateField source='updatedAt' showTime />
        </SimpleForm>
      </Edit>
    )
  },
  list: (props) => (
    <List filters={<Class.filter />} {...props}>
      <Datagrid
        rowClick='edit'
      >
        <TextField source='name' label='Name' />
        <ReferenceField label='School' source='schoolId' reference='school'>
          <TextField source='name' allowEmpty />
        </ReferenceField>
        <DateField source='createdAt' />
        <DateField source='updatedAt' />
      </Datagrid>
    </List>
  )
}

export default Class
